import { render, staticRenderFns } from "./UiToggle.vue?vue&type=template&id=7bf2b2a6&scoped=true"
import script from "./UiToggle.vue?vue&type=script&lang=js"
export * from "./UiToggle.vue?vue&type=script&lang=js"
import style0 from "./UiToggle.vue?vue&type=style&index=0&id=7bf2b2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf2b2a6",
  null
  
)

export default component.exports